'use client';

import { useEffect, useRef } from 'react';
import { Flex } from '@eqi-investimentos/react';
import { TRADING_VIEW_SCRIPT_URL } from '@/config/tradingView';
import { Icon } from '@/components/atoms/Icon';
export const TradingViewScript = () => {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let refValue: HTMLDivElement;
    const initWidget = () => {
      if (ref.current) {
        const script = document.createElement('script');
        script.setAttribute('data-nscript', 'afterInteractive');
        script.id = 'trading-view-script';
        script.src = scriptSRC;
        script.async = true;
        script.type = 'text/javascript';
        script.innerHTML = JSON.stringify(scriptHTML);
        if (!ref.current.querySelector('script[src="' + scriptSRC + '"]')) {
          ref.current.appendChild(script);
        }
        refValue = ref.current;
      }
    };
    requestAnimationFrame(initWidget);
    return () => {
      const tradingViewScript = document.getElementById('trading-view-script');
      if (refValue && tradingViewScript) {
        refValue.removeChild(tradingViewScript);
      }
    };
  }, [ref]);
  return <Flex ref={ref} sx={{
    '>div:nth-of-type(2)': {
      border: '1px solid',
      borderColor: 'border.secondary'
    }
  }} pointerEvents="none" data-sentry-element="Flex" data-sentry-component="TradingViewScript" data-sentry-source-file="index.tsx">
      <Flex alignItems="center" justifyContent="center" minW="2.75rem" maxW="2.75rem" h="2.75rem" bgColor="content.brand" data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Icon iconName="TrendingUp" width={26} height={26} color="content.inverse" data-sentry-element="Icon" data-sentry-source-file="index.tsx" />
      </Flex>
    </Flex>;
};
const scriptSRC = TRADING_VIEW_SCRIPT_URL;
const scriptHTML = {
  symbols: [{
    description: 'S&P 500',
    proName: 'FOREXCOM:SPXUSD'
  }, {
    description: 'Bitcoin',
    proName: 'BITSTAMP:BTCUSD'
  }, {
    description: 'Ethereum',
    proName: 'BITSTAMP:ETHUSD'
  }, {
    description: 'Ibovespa',
    proName: 'INDEX:IBOV'
  }, {
    description: 'Dólar',
    proName: 'FX_IDC:USDBRL'
  }, {
    description: 'Ouro',
    proName: 'TVC:GOLD'
  }, {
    description: 'Petróleo',
    proName: 'CAPITALCOM:OIL_BRENT'
  }],
  showSymbolLogo: true,
  isTransparent: true,
  displayMode: 'regular',
  colorTheme: 'light',
  locale: 'br'
};